// src/types/api.types.js

export const ApiResponse = {
    SUCCESS: 0,
    CREATED: 1,
    ERROR: 2,
    FORBIDDEN: 3,
    UNAUTHORIZED: 4,
    INVALID: 5,
    NOT_FOUND: 6,
    NO_CONTENT: 7,
    CONFLICT: 8,
    CRITICAL_ERROR: 9,
    UNAVAILABLE: 10
  };
  
  export const ApiErrorType = {
    VALIDATION: 'VALIDATION_ERROR',
    BUSINESS: 'BUSINESS_ERROR',
    TECHNICAL: 'TECHNICAL_ERROR',
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND'
  };
  
  export const createApiResponse = (data = null, status = ApiResponse.SUCCESS, message = '') => ({
    value: data,
    status,
    isSuccess: [ApiResponse.SUCCESS, ApiResponse.CREATED].includes(status),
    message,
    errors: [],
    validationErrors: []
  });
  
  export const createErrorResponse = (error, type = ApiErrorType.TECHNICAL) => ({
    value: null,
    status: ApiResponse.ERROR,
    isSuccess: false,
    message: error.message,
    errors: [{ type, message: error.message }],
    validationErrors: error.validationErrors || []
  });